import React, { useEffect, useContext } from 'react';
import dictData from 'dictionary';
import CustomButton from 'components/shared/CustomButton';
import { ReactComponent as Indicator } from 'images/icons/indicator-arrow.svg';
import useScreenOrientation from 'hooks/useScreenOrientation';
import { MatchMediaContext } from 'context/MatchMediaContext';
import routeList from 'routes/routeList';
import SmallArrow from 'images/icons/SmallArrow';

const HomeBanner: React.FC = () => {
  const { isXs } = useContext(MatchMediaContext);
  const currentOrientation = useScreenOrientation();
  // mobile 100vh (considering browser nav)
  useEffect(() => {
    const screenHeight = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${screenHeight * 0.01}px`);
  }, [currentOrientation]);

  return (
    <>
      <section className="home-banner-wrapper">
        <div className="home-banner-background" />
        <div className="home-banner-overlay" />
        <div className="home-pulsing-circles-wrapper">
          <div className="inner-circle" />
        </div>
        <div className="content-wrapper home-banner-heading">
          <div className="home-pulsing-circle" />
          <h1 className="heading">{dictData.home.bannerTitle}</h1>
          <p>{isXs ? dictData.home.shortBannerDescription : dictData.home.bannerDescription}</p>
          <div className="home-banner-cta-wrapper">
            <CustomButton to={routeList.listOSE} text={dictData.buttonText.join} primary className="home-cta-primary" />
            <CustomButton
              to={routeList.oseInternet}
              text={dictData.buttonText.readMore}
              link
              icon={<SmallArrow />}
              iconPlacement="right"
              className="home-cta-link d-none d-sm-inline-block"
            />
          </div>
        </div>
        <div className="content-wrapper-sm0 home-banner-eu">
          <div className="home-banner-logos">
            <div className="home-logo eu" />
            <div className="home-logo pl" />
          </div>
        </div>
      </section>
      <div className="home-arrow-indicator" aria-hidden="true">
        <Indicator />
      </div>
    </>
  );
};

export default HomeBanner;
